import React from 'react'
import { OneTrustSettings } from '../interfaces/OneTrustInterface'

const OneTrustButtons = () => {
  const key = OneTrustSettings.key || null;
  if(!key) return null;
  return (
    <>
      <button id="ot-sdk-btn" className="ot-sdk-show-settings">Cookie Settings</button>
      <div id="ot-sdk-cookie-policy"></div>
    </>
  )
}

export default OneTrustButtons;
